/**
 * Exhaustive guard for discriminated unions.
 * Use in switch statements to ensure all cases are handled at compile time.
 *
 * @example
 * type Status = "pending" | "active" | "closed"
 * function handleStatus(status: Status) {
 *   switch (status) {
 *     case "pending": return "Waiting..."
 *     case "active": return "In progress"
 *     case "closed": return "Done"
 *     default: exhaustiveGuard(status)
 *   }
 * }
 */
export function exhaustiveGuard(_value: never): never {
	throw new Error(`Exhaustive guard reached with unexpected value: ${String(_value)}`)
}

/**
 * Type guard to check if a value is defined (not null or undefined).
 * Useful for filtering arrays: items.filter(isDefined)
 */
export function isDefined<T>(value: T | null | undefined): value is T {
	return value !== null && value !== undefined
}
